var map = {
	"./Amphibi.jpg": "c801",
	"./BG.jpg": "c061",
	"./ButtonBg.jpg": "1b50",
	"./DM.png": "df50",
	"./FeaturedPartners.png": "7935",
	"./PhonePe.png": "18cd",
	"./asset1.png": "3883",
	"./asset2.png": "dc51",
	"./asset3.png": "a30f",
	"./asset4.png": "60b0",
	"./asset5.png": "2090",
	"./asset6.png": "5274",
	"./asset7.png": "25d2",
	"./asset8.png": "ff79",
	"./bannerJob.jpg": "1797",
	"./bg-img2-home.png": "227e",
	"./donationMethods.png": "0fc3",
	"./email.svg": "4a49",
	"./facebook.svg": "2a17",
	"./first.jpg": "071c",
	"./five.jpg": "4c05",
	"./footerLogo1.png": "98c1",
	"./four.jpg": "bd0e",
	"./greenBG.jpg": "d687",
	"./hcl.png": "4fc4",
	"./hdfcbank.jpg": "8960",
	"./homeimage.jpg": "cfbf",
	"./ifaw.png": "6bb8",
	"./inl.png": "4aa4",
	"./iucn.png": "36ed",
	"./japan.png": "bb4b",
	"./leaf.png": "39a6",
	"./linkdin.svg": "3906",
	"./no-image.png": "ec7e",
	"./oracle.png": "56e7",
	"./orangebtn.png": "8837",
	"./ourImpact.png": "e2d3",
	"./owl.jpg": "b013",
	"./payubiz.png": "0354",
	"./payumoney.jpg": "4f5c",
	"./pig.jpg": "c171",
	"./sample.html": "332f",
	"./sample_files/29088559": "102e",
	"./sample_files/83569277": "0227",
	"./sample_files/83569277(1)": "360d",
	"./sample_files/83569277(2)": "1c33",
	"./sample_files/behaviors-0fe4eee2.js.download": "fdce",
	"./sample_files/behaviors-f3a9d72bb1bfd685a5472d6f3ce39093.css": "1d88",
	"./sample_files/chunk-color-modes-c614803b.js.download": "d005",
	"./sample_files/chunk-cookies-48f59dde.js.download": "0332",
	"./sample_files/chunk-copy-8e2b71a2.js.download": "c33f",
	"./sample_files/chunk-edit-ca75799c.js.download": "2377",
	"./sample_files/chunk-feature-callout-element-5adc4562.js.download": "c326",
	"./sample_files/chunk-frameworks-a010e3b0.js.download": "57a3",
	"./sample_files/chunk-get-repo-element-0f9efa0a.js.download": "4521",
	"./sample_files/chunk-input-demux-c7a2fde2.js.download": "5483",
	"./sample_files/chunk-notification-list-focus-028f6594.js.download": "89f3",
	"./sample_files/chunk-overview-15e46e8d.js.download": "561b",
	"./sample_files/chunk-ref-selector-77dccb93.js.download": "f49e",
	"./sample_files/chunk-responsive-underlinenav-1a1a870c.js.download": "64c1",
	"./sample_files/chunk-tag-input-826c3ba1.js.download": "0843",
	"./sample_files/chunk-vendor-d15f4577.js.download": "f8fe",
	"./sample_files/code-menu-63d4027d.js.download": "57a4",
	"./sample_files/codespaces-8849dd19.js.download": "50ab",
	"./sample_files/command-palette-d7c00345.js.download": "997b",
	"./sample_files/dark-848e5bda8a9313d9e37e362b7eecd7a8.css": "c23a",
	"./sample_files/environment-2bf92300.js.download": "ce9d",
	"./sample_files/frameworks-4f7378e77856098b0bf3229fbb7cb27b.css": "3f9a",
	"./sample_files/github-a916573738a9c6fb608ef2f768e82e27.css": "19f3",
	"./sample_files/light-d46e2b60992dc114d02a7edf55f254c4.css": "db76",
	"./sample_files/optimizely-b2d3c6c8.js.download": "3c45",
	"./sample_files/repositories-a996d123.js.download": "e5a6",
	"./sample_files/saved_resource.html": "804d",
	"./sample_files/tab-size-fix-30224561f6d0a13e045c2e9a5b1e5682.css": "cea1",
	"./sample_files/topic-suggestions-09f25cf6.js.download": "398e",
	"./second.jpg": "eed1",
	"./six.jpg": "eaf6",
	"./tata.png": "b894",
	"./third.jpg": "3616",
	"./twitter.svg": "2879",
	"./whyus.png": "add4",
	"./wlt.png": "6c16",
	"./wti-banner.jpg": "9083"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d25";